// src/config.js
const hostname = window.location.hostname
export const API_URL =
  hostname === 'dev.karamale.com'
    ? 'https://dev.karamale.com'
    : hostname === 'stage.karamale.com'
      ? 'https://stage.karamale.com'
      : hostname === 'admin.karamale.com'
        ? 'https://admin.karamale.com'
        : hostname === 'karamale.com'
          ? 'https://karamale.com'
          : 'https://dev.karamale.com'
// export const API_URL = process.env.REACT_APP_API_URL
